import React, { useState } from "react";
import { ProductCardThumbnail } from "./ProductCardThumbnail";
import { CarouselImages } from "./CarouselImages";
import { UserFlows } from "./UserFlows";
import { ProductFiles } from "./ProductFiles";
import { OfferingFreeVersion } from "./OfferingFreeVersion";

export const ImageTab = ({data, setData, handleSubmit}) => {

  return (
    <div>
      <ProductCardThumbnail data={data} setData={setData}/>
      <CarouselImages data={data} setData={setData}/>
      <UserFlows data={data} setData={setData}/>
      <ProductFiles data={data} setData={setData}/>
      <OfferingFreeVersion data={data} setData={setData}/>
      {/* <button onClick={handleSubmit}>Submit</button> */}
    </div>
  );
};
